import { useEffect, useMemo, useState } from 'react';
import { UseQueryResult } from 'react-query';

import { SkillTaxonomyTreeDto } from '@eva/types/dto';

import { convertError, expandHighlightedSkills, handleExpandTree } from '../functions';
import { SkillTaxnomyChildDto } from '../types';

type useSkillTaxonomyTreeType = {
  useFetchSkillTaxonomyTree: () => UseQueryResult<SkillTaxonomyTreeDto>;
  defaultExpandedSkills?: number[];
};

export const useSkillTaxonomyTree = (props: useSkillTaxonomyTreeType) => {
  const [skillTaxonomyTree, setSkillTaxonomyTree] = useState<
    SkillTaxonomyTreeDto & {
      expanded?: boolean;
    }
  >();

  const defaultExpandedSkills = useMemo(() => props.defaultExpandedSkills || [], [props.defaultExpandedSkills]);

  const [error, setError] = useState('');

  const { isLoading, data, error: fetchSkillTaxonomyTreeError } = props.useFetchSkillTaxonomyTree();

  useEffect(() => {
    setSkillTaxonomyTree(
      expandHighlightedSkills(data as SkillTaxnomyChildDto, defaultExpandedSkills) as SkillTaxonomyTreeDto,
    );
  }, [data, defaultExpandedSkills]);

  useEffect(() => {
    if (fetchSkillTaxonomyTreeError) {
      const err = convertError(fetchSkillTaxonomyTreeError);
      setError(err);
    }
  }, [fetchSkillTaxonomyTreeError]);

  const onExpandTree = (isExpand: boolean) => {
    const tree = handleExpandTree({
      tree: skillTaxonomyTree,
      isExpand,
    });
    setSkillTaxonomyTree(tree);
  };

  return {
    isLoading,
    onExpandTree,
    skillTaxonomyTree,
    setSkillTaxonomyTree,
    error,
  };
};
